export default {
    props: {
        expand: {
            type: Boolean,
            kComposite: 'expand'
        }, 
        name: {
            type: String,
            kComposite: 'name'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-datasource-vue-wrapper/src/KendoPivotRow/Rows.js